import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Badge, Table } from "reactstrap";
import { GetCookieToken } from "../../Cookie/GetCookie";
import { toThaiDate } from "../../../helpers/date_helper"
import axios from "axios";
const REACT_APP_API_E_OFFICE = process.env.REACT_APP_API_E_OFFICE;
const REACT_APP_API_CORS = process.env.REACT_APP_API_CORS;

const Vehicle = () => {

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const getData = async (type) => {
    setLoading(true);
    const userEofficeAccessToken = GetCookieToken("userEofficeAccessToken");
    const config = {
      headers: {
        Authorization: `${userEofficeAccessToken}`,
        "Content-Type": "application/x-www-form-urlencoded",
        "Access-Control-Allow-Origin": "*",
        'Access-Control-Allow-Credentials': true
      }
    }
    const url = `${REACT_APP_API_CORS}/e-office/proxy?url=${REACT_APP_API_E_OFFICE}/api/gateway/car_reservation/reserve_list?page=1{q}limit=5`;
    await axios.get(url, config).then(async response => {
      if (response?.data?.status === 'success') {
        setData(response?.data?.data);
        setLoading(false);
      } else {
        setData([]);
        setLoading(false);
      }
    }).catch(error => {
    });
    setLoading(false);
  }

  useEffect(() => {
    const thisEffect = async () => {
      const userEofficeAccessToken = GetCookieToken("userEofficeAccessToken");
      if (userEofficeAccessToken) {
        await getData();
      }
    }
    thisEffect();
  }, [])

  return (
    <div>
      <Table hover striped responsive
        style={{ whiteSpace: "nowrap", textAlign: "center", verticalAlign: "middle" }} className="table table-hover"
      >
        <thead className="table-primary">
          <tr>
            <th>วันที่จอง</th>
            <th>ชื่อจุดขึ้นรถ</th>
            <th>จุดหมายปลายทาง</th>
            <th>สถานะ</th>
          </tr>
        </thead>
        <tbody className="table-light">
          {(data.length > 0 && loading === false) ?
            data.slice(0, 5).map(i => {
              return (
                <tr key={i} style={{ cursor: "pointer" }} onClick={() => window.open(i?.eoffice_url, "_blank")}>
                  <td className="">{toThaiDate(i?.res_datestart, true, false) || ''} - {toThaiDate(i?.res_dateend, true, false) || ''}</td>
                  <td className="text-center">{i?.startlocat_name || ''}</td>
                  <td className="text-center">{i?.res_endlocat || ''}</td>
                  <td className="text-center"><Badge style={{ fontSize: '12px' }}>{i?.text_status || ''}</Badge></td>
                </tr>
              );
            }) :
            <tr key={'1'}>
              <td className="text-center" colSpan={4}>
                {loading ? <i class="fa-duotone fa-spinner-third fa-spin"></i> : 'ไม่พบข้อมูล'}
              </td>
            </tr>}
        </tbody>
      </Table>
      <div className="mt-2" style={{ textAlign: "end" }}>
        <Link to="https://eoffice.opdc.go.th/car-reservation/home" target="_blank" className="btn btn-primary  btn-md">
          ไประบบจองยานพาหนะ{" "}<i className="mdi mdi-arrow-right ms-1"></i>
        </Link>
      </div>
    </div>
  );
};

export default Vehicle;
